export const VEHICLE_HISTORY_CHECK_TEXT_KEYS = Object.freeze({
	financeAgreement: 'financeAgreement',
	importCheck: 'importCheck',
	insuranceWriteOffDamage: 'insuranceWriteOffDamage',
	insuranceWriteOffInsurance: 'insuranceWriteOffInsurance',
	mot: 'mot',
	plateTransfer: 'plateTransfer',
	salvageCheck: 'salvageCheck',
	securityCheck: 'securityCheck',
	stolen: 'stolen',
	taxiCheck: 'taxiCheck',
});

export default {
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.financeAgreement]: {
		success: 'Not on finance.',
		title: 'Finance agreement',
		warning: 'Has {agreementCount} finance {agreement} recorded on the CAP HPI Asset Register.',
	},
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.importCheck]: {
		success: 'Not imported from outside of the EU.',
		title: 'Import check',
		warning: 'Has been imported from outside of the EU.',
	},
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.insuranceWriteOffDamage]: {
		success: 'Not a write-off for damage.',
		title: 'Insurance write off (damage)',
		warning: 'Vehicle has been too badly damaged to be repaired economically or safely.',
	},
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.insuranceWriteOffInsurance]: {
		success: 'Not a write-off for theft.',
		title: 'Insurance write off (insurance)',
		warning: 'Vehicle has been recovered in a condition beyond repair.',
	},
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.mot]: {
		success: 'Has valid MOT certificate.',
		title: 'MOT',
		warning: 'MOT certificate expired on {expiryDate}.',
	},
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.plateTransfer]: {
		success: 'No plate changes.',
		title: 'Plate transfer',
		warning: 'Vehicle had plate changes.',
	},
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.salvageCheck]: {
		success: 'Not been salvaged.',
		title: 'Salvage check',
		warning: 'Has been salvaged.',
	},
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.securityCheck]: {
		success: 'Not on a security watch register.',
		title: 'Security check',
		warning: 'On a security watch register.',
	},
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.stolen]: {
		success: 'Not been stolen.',
		title: 'Stolen',
		warning: 'Has been recorded on a Police National Computer as stolen.',
	},
	[VEHICLE_HISTORY_CHECK_TEXT_KEYS.taxiCheck]: {
		success: 'Not been used as a taxi.',
		title: 'Taxi check',
		warning: 'Has been used as a taxi ({source}, {dateFrom} - {dateTo}).',
	},
};
